<template>
  <div align="Left" style="background-color: rgba(18, 180, 235, 0.1);">

    <md-card style="margin: 0" v-if="!isLoading">
      <div class="md-layout md-alignment-center-center md-card-header-green" style="background: #fff; margin: 0">
        <div class="md-layout-item md-size-100" style="padding-left: 0px; padding-right: 0px; margin: 0">
          <md-card-header class="md-with-hover md-card-header-icon md-card-header-green" style="margin: 0">
            <div class="card-icon" style="margin-left: 5px; margin-top: -27px; margin-right: 0px;">
              <i class="material-icons">people</i>
            </div>
            <span style="margin-left: 15px; font-size: 1.5rem; font-weight: 400; color: green; padding-top: 1rem"
              >Patient Information</span
            >
            <md-card-content>
              <div class="md-layout">
                <label class="md-layout-item  md-size-15 md-form-label" style="text-align: center">First Name</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2" v-html="patientInfo.person.firstName" />
                </div>

                <label class="md-layout-item md-size-15 md-form-label" style="text-align: center">Last Name</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ patientInfo.person.lastName }}</md-field>
                </div>
              </div>

              <div class="md-layout">
                <label class="md-layout-item  md-size-15 md-form-label" style="text-align: center">Email</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2" v-html="patientInfo.person.email" />
                </div>

                <label class="md-layout-item md-size-15 md-form-label" style="text-align: center">Phone</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ patientInfo.person.cellNumber }}</md-field>
                </div>
              </div>

              <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label" style="text-align: center">DOB (Age)</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2"> {{ getDob }} </md-field>
                </div>

                <label class="md-layout-item md-size-15 md-form-label" style="text-align: center">Gender</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2" style="text-transform: capitalize;">{{
                    patientInfo.person.gender
                  }}</md-field>
                </div>
              </div>

              <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label" style="text-align: center">Eyewear</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ patientInfo.wearCorrectiveLense || "none" }}</md-field>
                </div>
              </div>

              <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label" style="text-align: center">Address</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ patientInfo.person.address }}</md-field>
                </div>
              </div>

              <div class="md-layout">
                <label class="md-layout-item md-size-15 md-form-label" style="text-align: center">City/St/Zip</label>
                <div class="md-layout-item" style="padding-left:5px;">
                  <md-field class="field2">{{ getCityStZip }}</md-field>
                </div>
              </div>
            </md-card-content>
          </md-card-header>
        </div>
      </div>
    </md-card>

    <hr v-if="!isLoading" style="width: 95%; border-bottom: 2px solid rgb(66, 105, 167); margin:30px 0" />

    <ReaderAvailable v-if="!isLoading" :screeningsProp="screeningsM0" />

    <hr v-if="!isLoading" style="width: 95%; border-bottom: 2px solid rgb(66, 105, 167); margin:30px 0" />

    <ReaderOnhold v-if="!isLoading" :screeningsOnHoldProp="screeningsOnhold" />

    <loader :is-visible="isLoading" />
  </div>
</template>
<script>
import loader from "@/components/GlobeChek/loader.vue"
import screeningService from "@/services/screenings-service"

export default {
  components: {
    loader,
    ReaderOnhold: () => import("@/pages/Portal/Views/Reader/Pages/Onhold.vue"),
    ReaderAvailable: () => import("@/pages/Portal/Views/Reader/Pages/Screenings.vue")
  },
  data() {
    return {
      isLoading: true,
      patientInfo: this.$route.params,
      screeningsOnhold: null,
      screeningsM0: null
    }
  },
  async created() {
    if (!this.patientInfo || Object.keys(this.patientInfo).length === 0) {
      this.patientInfo = JSON.parse(localStorage.getItem("patientInfo")) || {}
    } else {
      localStorage.setItem("patientInfo", JSON.stringify(this.patientInfo))
    }

    await this.fetchScreenings()
  },
  computed: {
    getDob() {
      if (!this.patientInfo || !this.patientInfo.person.dob) return ""

      const date = new Date(this.patientInfo.person.dob)

      const formattedDate = date.toLocaleDateString("en-US")

      const today = new Date()
      let age = today.getFullYear() - date.getFullYear()
      const monthDiff = today.getMonth() - date.getMonth()
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
        age--
      }

      return `${formattedDate} (${age})`
    },
    getCityStZip() {
      return `${this.patientInfo.person.city || ""}, ${this.patientInfo.person.state || ""} - ${
        this.patientInfo.person.zipCode || ""
      }`;
    }
  },
  methods: {
    async fetchScreenings() {
      try {
        this.isLoading = true;
        const username = sessionStorage.getItem("username");
        const userID = this.patientInfo.userID;

        const [onholdData, m0Data] = await Promise.all([
          screeningService.getScreeningByPersonId("onhold", username, userID),
          screeningService.getScreeningByPersonId("m0", username, userID)
        ])

        this.screeningsOnhold = onholdData
        this.screeningsM0 = m0Data
      } catch (err) {
        this.error = "Error loading screenings"
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
